const IMG = {
  cargoShip: "/hero-ship.jpg",
  aerialPort: "/port-aerial.jpg",
  busyPort: "/port-busy.jpg",
};

const translations = {
  es: {
    nav: {
      services: "Servicios",
      howItWorks: "Proceso",
      whyUs: "Ventajas",
      pricing: "Precios",
      compare: "Comparativa",
      cta: "Contactar por WhatsApp",
    },
    hero: {
      overline: "COMERCIO INTERNACIONAL SIMPLIFICADO",
      headline: "Tu Departamento Externo de Compras e Importaci\u00f3n",
      subheadline: "Externalizamos tu departamento de compras y log\u00edstica internacional. Gesti\u00f3n de proveedores, transporte, aduanas y seguimiento completo.",
      cta: "Agenda una Llamada Gratis",
      ctaSecondary: "Ver C\u00f3mo Funciona",
      image: IMG.cargoShip,
    },
    painPoints: {
      overline: "EL PROBLEMA",
      headline: "Importar No Deber\u00eda Sentirse Como Apagar Incendios",
      image: IMG.aerialPort,
      problems: [
        { title: "Complejidad Abrumadora", desc: "Demasiados proveedores, documentaci\u00f3n y normativas que requieren expertise." },
        { title: "Coste de Equipo Interno", desc: "N\u00f3minas, cargas sociales, formaci\u00f3n y compromisos a largo plazo." },
        { title: "Falta de Flexibilidad", desc: "Equipos r\u00edgidos ante cambios de volumen o nuevas rutas." },
      ],
      resolution: "OKontainers resuelve todo esto.",
    },
    valueProposition: {
      overline: "VENTAJAS",
      headline: "Por Qu\u00e9 Elegirnos",
      items: [
        { num: "01", title: "Un \u00fanico punto de contacto", desc: "para toda tu operativa internacional." },
        { num: "02", title: "Experiencia senior", desc: "desde el primer d\u00eda, sin curva de aprendizaje." },
        { num: "03", title: "Escalable y flexible", desc: "sin permanencia ni compromisos largos." },
        { num: "04", title: "100% deducible fiscalmente", desc: "reduce tu base imponible." },
        { num: "05", title: "Costes previsibles", desc: "sabes exactamente lo que pagas cada mes." },
        { num: "06", title: "Sin selecci\u00f3n ni RRHH", desc: "olv\u00eddate de contratar y formar personal." },
        { num: "07", title: "Control total", desc: "visibilidad en tiempo real de cada operaci\u00f3n." },
        { num: "08", title: "Menor riesgo operativo", desc: "no dependes de una sola persona." },
      ],
    },
    howItWorks: {
      overline: "PROCESO",
      headline: "C\u00f3mo Funciona",
      image: IMG.busyPort,
      steps: [
        { number: "01", title: "T\u00fa Solicitas la Operaci\u00f3n", desc: "Nos contactas, nos dices que quieres importar y el mail de tu proveedor." },
        { number: "02", title: "Negociamos con tu Proveedor", desc: "Negociamos precios, packaging, etiquetas y tiempo de producci\u00f3n directamente con tu proveedor." },
        { number: "03", title: "Coordinamos el Transporte", desc: "Organizamos el transporte internacional con tu transitario de confianza, tanto sea mar\u00edtimo, a\u00e9reo o terrestre." },
        { number: "04", title: "Revisamos la Documentaci\u00f3n", desc: "Preparamos y revisamos toda la documentaci\u00f3n necesaria para gestionar el despacho de aduanas y que no haya problemas." },
        { number: "05", title: "Gestionamos la Aduana", desc: "Gestionamos el despacho aduanero en el pa\u00eds de destino." },
        { number: "06", title: "Entregamos en tu Almac\u00e9n", desc: "Tu mercanc\u00eda llega a tu almac\u00e9n, lista para operar." },
      ],
      promise: "Te mantendremos informado en cada etapa del proceso con feedback diarios. Siempre y en todo momento sabr\u00e1s el estado de tu operaci\u00f3n!",
    },
    services: {
      overline: "SERVICIOS",
      headline: "Todo en Un Solo Partner",
      items: [
        { title: "Sourcing y Negociaci\u00f3n", icon: "Search" },
        { title: "Gesti\u00f3n de Compras", icon: "ClipboardList" },
        { title: "Log\u00edstica Mar\u00edtima (FCL/LCL)", icon: "Ship" },
        { title: "Transporte A\u00e9reo", icon: "Plane" },
        { title: "Transporte Terrestre", icon: "Truck" },
        { title: "Aduanas y Documentaci\u00f3n", icon: "Shield" },
        { title: "Seguimiento en Tiempo Real", icon: "MapPin" },
        { title: "Optimizaci\u00f3n de Costes", icon: "Calculator" },
      ],
    },
    ecommerce: {
      overline: "ECOMMERCE & ACADEMIAS",
      headline: "\u00bfVendes por Ecommerce? Somos tu Socio Ideal",
      subheadline: "Si vendes en Amazon FBA, en tu propia tienda online o est\u00e1s empezando con tu marca privada, nosotros gestionamos toda la importaci\u00f3n por ti.",
      forSellers: {
        title: "Para Sellers y Marcas",
        items: [
          "Negociamos directamente con tu f\u00e1brica en China",
          "Gestionamos packaging, etiquetado y normativa CE",
          "Coordinamos el env\u00edo directo a almac\u00e9n de Amazon o tu 3PL",
          "T\u00fa te enfocas en vender, nosotros en importar",
        ],
      },
      forAcademies: {
        title: "Para Academias y Mentores",
        items: [
          "Ofr\u00e9celes a tus alumnos un servicio profesional de importaci\u00f3n",
          "Condiciones especiales para comunidades y grupos",
          "Tus alumnos empiezan a importar desde el d\u00eda 1 sin errores",
          "Colaboraci\u00f3n a medida: comisiones, marca blanca o referidos",
        ],
      },
      cta: "Quiero Saber M\u00e1s",
    },
    pricing: {
      overline: "PRECIOS",
      headline: "Simple, Transparente y Escalable",
      subheadline: "Precio basado en el n\u00famero de operaciones mensuales. A mayor volumen, menor coste por operaci\u00f3n.",
      operationNote: "1 operaci\u00f3n = 1 importaci\u00f3n de un pedido, sin importar si es una carga LCL o un contenedor de 40HQ. Cada importaci\u00f3n cuenta como 1 operaci\u00f3n.",
      plans: [
        { name: "Starter", operations: "Hasta 2 operaciones/mes", price: "500", suffix: "\u20ac", highlighted: false },
        { name: "Business", operations: "De 3 a 5 operaciones/mes", price: "1.200", suffix: "\u20ac", highlighted: true },
        { name: "Professional", operations: "De 6 a 10 operaciones/mes", price: "2.000", suffix: "\u20ac", highlighted: false },
        { name: "Enterprise", operations: "M\u00e1s de 10 operaciones/mes", price: "Custom", suffix: "", isCustom: true, highlighted: false },
      ],
      cta: "Solicitar Presupuesto",
      customLabel: "A coordinar",
    },
    comparison: {
      overline: "COMPARATIVA",
      headline: "Equipo Interno vs OKontainers",
      internal: { title: "Equipo Interno", items: ["Salario fijo + cargas sociales", "Selecci\u00f3n y formaci\u00f3n", "Capacidad limitada", "Dependencia de una persona"] },
      okontainers: { title: "OKontainers", items: ["Coste flexible y previsible", "Experiencia senior inmediata", "Escalable seg\u00fan volumen", "Equipo sin dependencia"] },
    },
    calculator: {
      overline: "CALCULADORA DE AHORRO",
      headline: "Cu\u00e1nto Ahorrar\u00edas con Nosotros",
      subheadline: "Mueve el control para ver el ahorro seg\u00fan tu volumen de operaciones.",
      opsLabel: "Operaciones mensuales",
      internalLabel: "Equipo Interno",
      savingsLabel: "Tu Ahorro",
      perMonth: "/mes",
      perYear: "/a\u00f1o de ahorro",
      cta: "Quiero Ahorrar Ahora",
      disclaimer: "* Estimaci\u00f3n basada en coste medio de un empleado de comercio internacional en Espa\u00f1a (salario + S.S. + formaci\u00f3n + herramientas).",
    },
    dossier: {
      cta: "Descargar Cat\u00e1logo",
    },
    simulator: {
      overline: "ENCUENTRA TU SOLUCI\u00d3N",
      headline: "\u00bfCu\u00e1l Es Tu Situaci\u00f3n?",
      subheadline: "Selecciona tu perfil y descubre qu\u00e9 har\u00edamos por ti.",
      whatWeDo: "LO QUE HACEMOS POR TI",
      cta: "Hablemos de Tu Caso",
      prompt: "Selecciona tu perfil para ver una soluci\u00f3n personalizada.",
      profiles: [
        {
          label: "Vendo en Amazon FBA",
          title: "Sellers de Amazon FBA",
          situation: "Necesitas importar producto desde China, gestionar packaging, etiquetado FBA y enviar directo al almac\u00e9n de Amazon.",
          actions: [
            "Negociamos con tu f\u00e1brica precios, MOQ y etiquetado FBA",
            "Coordinamos el transporte directo al almac\u00e9n de Amazon",
            "Gestionamos la documentaci\u00f3n aduanera y el marcado CE",
            "Te avisamos cuando tu mercanc\u00eda est\u00e1 lista para vender",
          ],
          result: "T\u00fa te dedicas a lanzar listings y optimizar PPC. Nosotros traemos el producto.",
          whatsapp: "Hola OKontainers! Vendo en Amazon FBA y necesito ayuda con mis importaciones.",
        },
        {
          label: "Importo materia prima",
          title: "F\u00e1bricas e Industria",
          situation: "Compras materia prima o componentes en el extranjero para tu producci\u00f3n. Necesitas entregas puntuales y costes controlados.",
          actions: [
            "Buscamos y validamos proveedores alternativos para mejorar precios",
            "Coordinamos entregas recurrentes alineadas con tu producci\u00f3n",
            "Gestionamos toda la documentaci\u00f3n t\u00e9cnica y certificados",
            "Optimizamos rutas y consolidamos env\u00edos para reducir costes",
          ],
          result: "Tu l\u00ednea de producci\u00f3n nunca para. Nosotros garantizamos el suministro.",
          whatsapp: "Hola OKontainers! Importo materia prima y quiero optimizar mis operaciones.",
        },
        {
          label: "Soy distribuidor",
          title: "Distribuidores y Mayoristas",
          situation: "Importas producto terminado para distribuir en Espa\u00f1a o Europa. Manejas m\u00faltiples proveedores y referencias.",
          actions: [
            "Gestionamos la relaci\u00f3n con todos tus proveedores desde un solo punto",
            "Coordinamos env\u00edos FCL y LCL seg\u00fan tu volumen por referencia",
            "Consolidamos mercanc\u00eda de distintos or\u00edgenes en un solo env\u00edo",
            "Te damos visibilidad total de cada pedido en tiempo real",
          ],
          result: "Tu almac\u00e9n siempre abastecido. T\u00fa enfocado en vender a tus clientes.",
          whatsapp: "Hola OKontainers! Soy distribuidor y necesito gestionar mis importaciones.",
        },
        {
          label: "Marca propia / Private Label",
          title: "Marcas Propias y Private Label",
          situation: "Est\u00e1s creando tu marca y necesitas fabricar en China con tu dise\u00f1o, packaging y etiquetado personalizado.",
          actions: [
            "Te ayudamos a encontrar f\u00e1bricas fiables para tu producto",
            "Negociamos precios, packaging personalizado y etiquetado",
            "Gestionamos muestras, control de calidad y normativa CE",
            "Coordinamos todo el transporte hasta tu almac\u00e9n o 3PL",
          ],
          result: "Tu marca llega al mercado r\u00e1pido y sin errores. Nosotros nos encargamos de todo lo t\u00e9cnico.",
          whatsapp: "Hola OKontainers! Estoy creando mi marca propia y necesito ayuda para importar.",
        },
        {
          label: "Estoy empezando",
          title: "Primera Importaci\u00f3n",
          situation: "Nunca has importado. No sabes por d\u00f3nde empezar, qu\u00e9 documentos necesitas ni c\u00f3mo funciona la aduana.",
          actions: [
            "Te guiamos paso a paso en tu primera importaci\u00f3n",
            "Te explicamos qu\u00e9 necesitas: EORI, documentos, impuestos",
            "Negociamos con el proveedor para que no te tomen el pelo",
            "Gestionamos todo para que t\u00fa solo recibas la mercanc\u00eda",
          ],
          result: "Tu primera importaci\u00f3n sale bien. Sin errores, sin estr\u00e9s, sin sorpresas.",
          whatsapp: "Hola OKontainers! Quiero hacer mi primera importaci\u00f3n y necesito ayuda.",
        },
      ],
    },
    urgency: {
      text: "\u00bfTienes una operaci\u00f3n en curso que necesita ayuda? Podemos intervenir ahora mismo.",
      cta: "Necesito Ayuda Urgente",
      ctaShort: "Ayuda Urgente",
    },
    faq: {
      overline: "PREGUNTAS FRECUENTES",
      headline: "Todo Sobre Importar en Espa\u00f1a",
      items: [
        { q: "\u00bfNecesito un n\u00famero EORI para importar?", a: "S\u00ed, es obligatorio. El EORI (Economic Operators Registration and Identification) se compone de las letras ES + tu NIF. Lo emite la Agencia Tributaria autom\u00e1ticamente en tu primera importaci\u00f3n, aunque puedes solicitarlo antes en su Sede Electr\u00f3nica. Sin EORI, la aduana bloquea tu mercanc\u00eda." },
        { q: "\u00bfQu\u00e9 documentos necesito para importar?", a: "Los b\u00e1sicos son: factura comercial del proveedor, packing list, Bill of Lading (B/L) o Air Waybill, y certificado de origen. Dependiendo del producto, puede requerirse certificado CE, certificado sanitario o fichas de seguridad. Nosotros nos encargamos de revisar que todo est\u00e9 en orden." },
        { q: "\u00bfQu\u00e9 impuestos se pagan al importar en Espa\u00f1a?", a: "Se pagan aranceles (var\u00edan seg\u00fan la partida arancelaria del producto, generalmente entre 0% y 14%) y el IVA de importaci\u00f3n (21% en la mayor\u00eda de productos). El IVA de importaci\u00f3n es deducible en tu siguiente declaraci\u00f3n trimestral." },
        { q: "\u00bfCu\u00e1nto tarda una importaci\u00f3n desde China?", a: "Por mar\u00edtimo: 30-40 d\u00edas de tr\u00e1nsito + tiempo de producci\u00f3n. Por a\u00e9reo: 5-10 d\u00edas. Por tren: 18-22 d\u00edas. A esto se suma el despacho de aduanas (1-3 d\u00edas si la documentaci\u00f3n es correcta)." },
        { q: "\u00bfQu\u00e9 diferencia hay entre FCL y LCL?", a: "FCL (Full Container Load) es un contenedor completo solo para tu mercanc\u00eda. LCL (Less than Container Load) es cuando compartes contenedor con otros importadores. FCL es m\u00e1s econ\u00f3mico por metro c\u00fabico en vol\u00famenes grandes; LCL es ideal para env\u00edos peque\u00f1os." },
        { q: "\u00bfPuedo importar cualquier producto?", a: "Pr\u00e1cticamente s\u00ed, pero ciertos productos requieren certificaciones especiales: electr\u00f3nica y juguetes necesitan marcado CE, alimentos requieren controles sanitarios, y productos qu\u00edmicos necesitan fichas de seguridad. Te asesoramos sobre los requisitos de tu producto." },
        { q: "\u00bfNecesito un agente de aduanas?", a: "Es muy recomendable. El agente de aduanas tramita el DUA (Declaraci\u00f3n \u00danica Aduanera) ante la AEAT y se asegura de que toda la documentaci\u00f3n est\u00e9 correcta. Un error puede significar retenciones, multas o sobrecostes. Nosotros coordinamos esto por ti." },
        { q: "\u00bfOKontainers gestiona todo el proceso?", a: "S\u00ed. Desde la negociaci\u00f3n con el proveedor hasta la entrega en tu almac\u00e9n. Nos encargamos de compras, transporte, documentaci\u00f3n, aduanas y entrega. T\u00fa solo nos dices qu\u00e9 necesitas." },
      ],
    },
    auditForm: {
      overline: "EMPIEZA AHORA",
      headline: "Solicita tu Auditor\u00eda Gratuita",
      subheadline: "Analizamos tu operativa y te mostramos c\u00f3mo optimizarla.",
      namePlaceholder: "Tu nombre",
      companyPlaceholder: "Tu empresa",
      emailPlaceholder: "Tu email",
      cta: "Solicitar Auditor\u00eda",
      success: "Solicitud enviada. Nos pondremos en contacto contigo pronto.",
      error: "Error al enviar. Int\u00e9ntalo de nuevo o cont\u00e1ctanos por WhatsApp.",
      trustBadges: ["Sin permanencia", "Respuesta en 24h", "100% confidencial", "Sin compromiso"],
    },
    footer: {
      tagline: "Tu departamento externo de compras e importaci\u00f3n internacional. Trade made easy.",
      contact: "Contacto", followUs: "S\u00edguenos", legal: "Legal",
      location: "M\u00e1laga, Espa\u00f1a",
      cookiePolicy: "Pol\u00edtica de Cookies", privacyPolicy: "Pol\u00edtica de Privacidad",
      rights: "Todos los derechos reservados.",
    },
    whatsappWidget: {
      greeting: "Hola! \u00bfC\u00f3mo podemos ayudarte con tu pr\u00f3xima importaci\u00f3n?",
      cta: "Iniciar conversaci\u00f3n",
      prefilled: "Hola OKontainers! Me interesa saber m\u00e1s sobre vuestros servicios.",
    },
    cookies: { text: "Utilizamos cookies para mejorar tu experiencia. Al continuar navegando, aceptas nuestra pol\u00edtica de cookies.", accept: "Aceptar", reject: "Solo esenciales" },
  },
  en: {
    nav: { services: "Services", howItWorks: "Process", whyUs: "Benefits", pricing: "Pricing", compare: "Compare", cta: "Contact via WhatsApp" },
    hero: {
      overline: "INTERNATIONAL TRADE SIMPLIFIED",
      headline: "Your Outsourced Purchasing & Import Department",
      subheadline: "We manage suppliers, freight, customs, documentation, and delivery so your company saves time, reduces costs, and avoids operational chaos.",
      cta: "Book a Free Call", ctaSecondary: "See How It Works", image: IMG.cargoShip,
    },
    painPoints: {
      overline: "THE PROBLEM", headline: "Importing Shouldn\u2019t Feel Like Firefighting", image: IMG.aerialPort,
      problems: [
        { title: "Overwhelming Complexity", desc: "Too many suppliers, docs, and regulations requiring specialized expertise." },
        { title: "Cost of Internal Teams", desc: "Payroll, social security, training, and long-term commitments." },
        { title: "Lack of Flexibility", desc: "Rigid teams when volume changes or new routes emerge." },
      ],
      resolution: "OKontainers solves all of it.",
    },
    valueProposition: {
      overline: "BENEFITS", headline: "Why Choose Us",
      items: [
        { num: "01", title: "One single contact point", desc: "for all your international operations." },
        { num: "02", title: "Senior expertise", desc: "from day one, no learning curve." },
        { num: "03", title: "Scalable & flexible", desc: "no lock-in or long commitments." },
        { num: "04", title: "100% tax deductible", desc: "reduces your corporate tax base." },
        { num: "05", title: "Predictable costs", desc: "you know exactly what you pay each month." },
        { num: "06", title: "No hiring or HR", desc: "forget about recruiting and training staff." },
        { num: "07", title: "Full control", desc: "real-time visibility of every operation." },
        { num: "08", title: "Lower operational risk", desc: "no dependency on a single employee." },
      ],
    },
    howItWorks: {
      overline: "PROCESS", headline: "How It Works", image: IMG.busyPort,
      steps: [
        { number: "01", title: "You Request the Operation", desc: "Contact us, tell us what you want to import and your supplier\u2019s email." },
        { number: "02", title: "We Negotiate with Your Supplier", desc: "We negotiate prices, packaging, labels, and production timelines directly with your supplier." },
        { number: "03", title: "We Coordinate Transport", desc: "We organize international transport with your trusted forwarder, whether sea, air, or road." },
        { number: "04", title: "We Review Documentation", desc: "We prepare and review all documentation needed for customs clearance to ensure zero issues." },
        { number: "05", title: "We Handle Customs", desc: "We manage customs clearance in the destination country." },
        { number: "06", title: "We Deliver to Your Warehouse", desc: "Your goods arrive at your warehouse, ready to operate." },
      ],
      promise: "We\u2019ll keep you informed at every stage with daily feedback. You\u2019ll always know exactly where your operation stands!",
    },
    services: {
      overline: "SERVICES", headline: "Everything in One Partner",
      items: [
        { title: "Sourcing & Negotiation", icon: "Search" }, { title: "Purchase Management", icon: "ClipboardList" },
        { title: "Maritime Logistics (FCL/LCL)", icon: "Ship" }, { title: "Air Freight", icon: "Plane" },
        { title: "Road Transport", icon: "Truck" }, { title: "Customs & Documentation", icon: "Shield" },
        { title: "Real-Time Tracking", icon: "MapPin" }, { title: "Cost Optimization", icon: "Calculator" },
      ],
    },
    ecommerce: {
      overline: "ECOMMERCE & ACADEMIES",
      headline: "Sell Online? We\u2019re Your Ideal Partner",
      subheadline: "If you sell on Amazon FBA, your own store, or are starting your private label, we handle all the importing for you.",
      forSellers: {
        title: "For Sellers & Brands",
        items: [
          "We negotiate directly with your factory in China",
          "We manage packaging, labeling, and CE compliance",
          "We coordinate shipping straight to Amazon or your 3PL",
          "You focus on selling, we handle importing",
        ],
      },
      forAcademies: {
        title: "For Academies & Mentors",
        items: [
          "Offer your students a professional import service",
          "Special conditions for communities and groups",
          "Your students start importing from day 1 without mistakes",
          "Custom collaboration: commissions, white-label, or referrals",
        ],
      },
      cta: "I Want to Know More",
    },
    pricing: {
      overline: "PRICING", headline: "Simple, Transparent & Scalable",
      subheadline: "Price based on the number of monthly operations. Higher volume means lower cost per operation.",
      operationNote: "1 operation = 1 import order, regardless of whether it\u2019s an LCL shipment or a 40HQ container. Each import counts as 1 operation.",
      plans: [
        { name: "Starter", operations: "Up to 2 operations/month", price: "500", suffix: "\u20ac", highlighted: false },
        { name: "Business", operations: "3 to 5 operations/month", price: "1,200", suffix: "\u20ac", highlighted: true },
        { name: "Professional", operations: "6 to 10 operations/month", price: "2,000", suffix: "\u20ac", highlighted: false },
        { name: "Enterprise", operations: "More than 10 operations/month", price: "Custom", suffix: "", isCustom: true, highlighted: false },
      ],
      cta: "Request Quote", customLabel: "Let\u2019s talk",
    },
    comparison: {
      overline: "COMPARISON", headline: "Internal Team vs OKontainers",
      internal: { title: "Internal Team", items: ["Fixed salary + social costs", "Recruitment and training", "Limited capacity", "Single person dependency"] },
      okontainers: { title: "OKontainers", items: ["Flexible, predictable cost", "Immediate senior expertise", "Scalable to volume", "Full team, no dependency"] },
    },
    calculator: {
      overline: "SAVINGS CALCULATOR",
      headline: "How Much Would You Save With Us",
      subheadline: "Move the slider to see savings based on your operation volume.",
      opsLabel: "Monthly operations",
      internalLabel: "Internal Team",
      savingsLabel: "Your Savings",
      perMonth: "/month",
      perYear: "/year savings",
      cta: "I Want to Save Now",
      disclaimer: "* Estimate based on average cost of an international trade employee in Spain (salary + S.S. + training + tools).",
    },
    dossier: {
      cta: "Download Catalog",
    },
    simulator: {
      overline: "FIND YOUR SOLUTION",
      headline: "What\u2019s Your Situation?",
      subheadline: "Select your profile and discover what we\u2019d do for you.",
      whatWeDo: "WHAT WE DO FOR YOU",
      cta: "Let\u2019s Talk About Your Case",
      prompt: "Select your profile to see a personalized solution.",
      profiles: [
        {
          label: "I sell on Amazon FBA",
          title: "Amazon FBA Sellers",
          situation: "You need to import from China, manage FBA packaging, labeling, and ship directly to Amazon\u2019s warehouse.",
          actions: [
            "We negotiate with your factory on prices, MOQ, and FBA labeling",
            "We coordinate shipping directly to Amazon\u2019s warehouse",
            "We handle customs documentation and CE marking",
            "We notify you when your goods are ready to sell",
          ],
          result: "You focus on listings and PPC. We bring the product.",
          whatsapp: "Hello OKontainers! I sell on Amazon FBA and need help with my imports.",
        },
        {
          label: "I import raw materials",
          title: "Factories & Industry",
          situation: "You buy raw materials or components abroad for your production. You need timely deliveries and controlled costs.",
          actions: [
            "We source and validate alternative suppliers for better prices",
            "We coordinate recurring deliveries aligned with your production",
            "We handle all technical documentation and certificates",
            "We optimize routes and consolidate shipments to reduce costs",
          ],
          result: "Your production line never stops. We guarantee supply.",
          whatsapp: "Hello OKontainers! I import raw materials and want to optimize operations.",
        },
        {
          label: "I\u2019m a distributor",
          title: "Distributors & Wholesalers",
          situation: "You import finished goods for distribution in Spain or Europe. You manage multiple suppliers and SKUs.",
          actions: [
            "We manage all your suppliers from a single point of contact",
            "We coordinate FCL and LCL shipments based on your volume per SKU",
            "We consolidate goods from different origins into one shipment",
            "We give you full visibility of every order in real time",
          ],
          result: "Your warehouse always stocked. You focus on selling to your clients.",
          whatsapp: "Hello OKontainers! I\u2019m a distributor and need help managing imports.",
        },
        {
          label: "Private Label / Own Brand",
          title: "Private Label & Own Brands",
          situation: "You\u2019re creating your brand and need to manufacture in China with custom design, packaging, and labeling.",
          actions: [
            "We help you find reliable factories for your product",
            "We negotiate prices, custom packaging, and labeling",
            "We manage samples, quality control, and CE compliance",
            "We coordinate all transport to your warehouse or 3PL",
          ],
          result: "Your brand reaches the market fast and error-free. We handle the technical side.",
          whatsapp: "Hello OKontainers! I\u2019m building my own brand and need import help.",
        },
        {
          label: "I\u2019m just starting",
          title: "First Import",
          situation: "You\u2019ve never imported. You don\u2019t know where to start, what documents you need, or how customs works.",
          actions: [
            "We guide you step by step through your first import",
            "We explain what you need: EORI, documents, taxes",
            "We negotiate with the supplier so you don\u2019t get ripped off",
            "We manage everything so you just receive the goods",
          ],
          result: "Your first import goes smoothly. No errors, no stress, no surprises.",
          whatsapp: "Hello OKontainers! I want to make my first import and need help.",
        },
      ],
    },
    urgency: {
      text: "Got an ongoing operation that needs help? We can step in right now.",
      cta: "I Need Urgent Help",
      ctaShort: "Urgent Help",
    },
    faq: {
      overline: "FAQ", headline: "Everything About Importing to Spain",
      items: [
        { q: "Do I need an EORI number to import?", a: "Yes, it\u2019s mandatory. The EORI is a European identification code required for any company importing goods from outside the EU. In Spain, it\u2019s your ES + tax ID. Without it, customs will block your goods." },
        { q: "What documents do I need to import?", a: "The basics: commercial invoice, packing list, Bill of Lading (B/L) or Air Waybill, and certificate of origin. Depending on the product, you may need CE certification, sanitary certificates, or safety data sheets. We handle reviewing everything." },
        { q: "What taxes are paid when importing to Spain?", a: "Customs duties (varies by product, typically 0-14%) and import VAT (21% for most products). Import VAT is deductible in your next quarterly tax return." },
        { q: "How long does an import from China take?", a: "By sea: 30-40 transit days + production time. By air: 5-10 days. By rail: 18-22 days. Add 1-3 days for customs clearance if documentation is correct." },
        { q: "What\u2019s the difference between FCL and LCL?", a: "FCL (Full Container Load) is a full container just for your goods. LCL (Less than Container Load) means sharing a container. FCL is cheaper per cubic meter for large volumes; LCL is ideal for smaller shipments." },
        { q: "Can I import any product?", a: "Practically yes, but certain products require special certifications: electronics and toys need CE marking, food requires sanitary controls, and chemicals need safety data sheets. We advise you on your product\u2019s requirements." },
        { q: "Do I need a customs agent?", a: "Highly recommended. A customs agent processes the customs declaration and ensures all documentation is correct. Errors can mean holds, fines, or extra costs. We coordinate this for you." },
        { q: "Does OKontainers manage the entire process?", a: "Yes. From supplier negotiation to warehouse delivery. We handle purchasing, transport, documentation, customs, and delivery. You just tell us what you need." },
      ],
    },
    auditForm: {
      overline: "GET STARTED", headline: "Request Your Free Audit",
      subheadline: "We analyze your operations and show you how to optimize them.",
      namePlaceholder: "Your name", companyPlaceholder: "Your company", emailPlaceholder: "Your email",
      cta: "Request Audit", success: "Request sent! We\u2019ll be in touch soon.",
      error: "Error sending. Please try again or contact us via WhatsApp.",
      trustBadges: ["No lock-in", "Response in 24h", "100% confidential", "No commitment"],
    },
    footer: {
      tagline: "Your outsourced purchasing & international import department. Trade made easy.",
      contact: "Contact", followUs: "Follow Us", legal: "Legal",
      location: "M\u00e1laga, Spain",
      cookiePolicy: "Cookie Policy", privacyPolicy: "Privacy Policy", rights: "All rights reserved.",
    },
    whatsappWidget: { greeting: "Hi! How can we help with your next import?", cta: "Start conversation", prefilled: "Hello OKontainers! I\u2019d like to learn more about your services." },
    cookies: { text: "We use cookies to improve your experience. By continuing to browse, you accept our cookie policy.", accept: "Accept", reject: "Essential only" },
  },
};

export default translations;
